import "../../index87.css";
import { jsx as be, jsxs as Rt, Fragment as At } from "react/jsx-runtime";
import * as h from "react";
import Ft, { useState as Yr, createContext as It, PureComponent as kt, useRef as Sr, useEffect as Ze, useCallback as wr } from "react";
import { CloseFillIcon as Mt } from "@ifrc-go/icons";
import { _ as Te } from "../../cs-piwRuCFZ.js";
import "../../type-BFTbooL7.js";
import Lt from "../BodyOverlay/index.js";
import Nt from "../Button/index.js";
import Dt from "../Container/index.js";
import Wt from "../../hooks/useTranslation.js";
import { g as jt } from "../../_commonjsHelpers-BkfeUUK-.js";
var $ = function() {
  return $ = Object.assign || function(r) {
    for (var t, n = 1, o = arguments.length; n < o; n++) {
      t = arguments[n];
      for (var a in t) Object.prototype.hasOwnProperty.call(t, a) && (r[a] = t[a]);
    }
    return r;
  }, $.apply(this, arguments);
};
function Ie(e, r) {
  var t = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, n = Object.getOwnPropertySymbols(e); o < n.length; o++)
      r.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[o]) && (t[n[o]] = e[n[o]]);
  return t;
}
function $t() {
  for (var e = 0, r = 0, t = arguments.length; r < t; r++) e += arguments[r].length;
  for (var n = Array(e), o = 0, r = 0; r < t; r++)
    for (var a = arguments[r], u = 0, i = a.length; u < i; u++, o++)
      n[o] = a[u];
  return n;
}
function Bt(e, r, t) {
  if (t || arguments.length === 2) for (var n = 0, o = r.length, a; n < o; n++)
    (a || !(n in r)) && (a || (a = Array.prototype.slice.call(r, 0, n)), a[n] = r[n]);
  return e.concat(a || Array.prototype.slice.call(r));
}
var Ae = "right-scroll-bar-position", Fe = "width-before-scroll-bar", zt = "with-scroll-bars-hidden", qt = "--removed-body-scroll-bar-size";
function Ne(e, r) {
  return typeof e == "function" ? e(r) : e && (e.current = r), e;
}
function Yt(e, r) {
  var t = Yr(function() {
    return {
      // value
      value: e,
      // last callback
      callback: r,
      // "memoized" public interface
      facade: {
        get current() {
          return t.value;
        },
        set current(n) {
          var o = t.value;
          o !== n && (t.value = n, t.callback(n, o));
        }
      }
    };
  })[0];
  return t.callback = r, t.facade;
}
var Ut = typeof window < "u" ? h.useLayoutEffect : h.useEffect, Or = /* @__PURE__ */ new WeakMap();
function Ur(e, r) {
  var t = Yt(null, function(n) {
    return e.forEach(function(o) {
      return Ne(o, n);
    });
  });
  return Ut(function() {
    var n = Or.get(t);
    if (n) {
      var o = new Set(n), a = new Set(e), u = t.current;
      o.forEach(function(i) {
        a.has(i) || Ne(i, null);
      }), a.forEach(function(i) {
        o.has(i) || Ne(i, u);
      });
    }
    Or.set(t, e);
  }, [e]), t;
}
function Hr(e) {
  return e;
}
function Vr(e, r) {
  r === void 0 && (r = Hr);
  var t = [], n = !1, o = {
    read: function() {
      if (n)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return t.length ? t[t.length - 1] : e;
    },
    useMedium: function(a) {
      var u = r(a, n);
      return t.push(u), function() {
        t = t.filter(function(i) {
          return i !== u;
        });
      };
    },
    assignSyncMedium: function(a) {
      for (n = !0; t.length; ) {
        var u = t;
        t = [], u.forEach(a);
      }
      t = {
        push: function(i) {
          return a(i);
        },
        filter: function() {
          return t;
        }
      };
    },
    assignMedium: function(a) {
      n = !0;
      var u = [];
      if (t.length) {
        var i = t;
        t = [], i.forEach(a), u = t;
      }
      var b = function() {
        var v = u;
        u = [], v.forEach(a);
      }, l = function() {
        return Promise.resolve().then(b);
      };
      l(), t = {
        push: function(v) {
          u.push(v), l();
        },
        filter: function(v) {
          return u = u.filter(v), t;
        }
      };
    }
  };
  return o;
}
function or(e, r) {
  return r === void 0 && (r = Hr), Vr(e, r);
}
function ar(e) {
  e === void 0 && (e = {});
  var r = Vr(null);
  return r.options = $({ async: !0, ssr: !1 }, e), r;
}
var Gr = function(e) {
  var r = e.sideCar, t = Ie(e, ["sideCar"]);
  if (!r)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var n = r.read();
  if (!n)
    throw new Error("Sidecar medium not found");
  return h.createElement(n, $({}, t));
};
Gr.isSideCarExport = !0;
function ir(e, r) {
  return e.useMedium(r), Gr;
}
var Xr = ar(), De = function() {
}, ur = h.forwardRef(function(e, r) {
  var t = h.useRef(null), n = h.useState({
    onScrollCapture: De,
    onWheelCapture: De,
    onTouchMoveCapture: De
  }), o = n[0], a = n[1], u = e.forwardProps, i = e.children, b = e.className, l = e.removeScrollBar, v = e.enabled, s = e.shards, m = e.sideCar, E = e.noIsolation, S = e.inert, c = e.allowPinchZoom, y = e.as, g = y === void 0 ? "div" : y, A = e.gapMode, O = Ie(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), R = m, d = Ur([t, r]), W = $($({}, O), o);
  return h.createElement(
    h.Fragment,
    null,
    v && h.createElement(R, { sideCar: Xr, removeScrollBar: l, shards: s, noIsolation: E, inert: S, setCallbacks: a, allowPinchZoom: !!c, lockRef: t, gapMode: A }),
    u ? h.cloneElement(h.Children.only(i), $($({}, W), { ref: d })) : h.createElement(g, $({}, W, { className: b, ref: d }), i)
  );
});
ur.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
ur.classNames = {
  fullWidth: Fe,
  zeroRight: Ae
};
function ke() {
  return ke = Object.assign ? Object.assign.bind() : function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var n in t) ({}).hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
    return e;
  }, ke.apply(null, arguments);
}
var Ke = { exports: {} }, Ce = { exports: {} }, L = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Tr;
function Ht() {
  if (Tr) return L;
  Tr = 1;
  var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, t = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, u = e ? Symbol.for("react.provider") : 60109, i = e ? Symbol.for("react.context") : 60110, b = e ? Symbol.for("react.async_mode") : 60111, l = e ? Symbol.for("react.concurrent_mode") : 60111, v = e ? Symbol.for("react.forward_ref") : 60112, s = e ? Symbol.for("react.suspense") : 60113, m = e ? Symbol.for("react.suspense_list") : 60120, E = e ? Symbol.for("react.memo") : 60115, S = e ? Symbol.for("react.lazy") : 60116, c = e ? Symbol.for("react.block") : 60121, y = e ? Symbol.for("react.fundamental") : 60117, g = e ? Symbol.for("react.responder") : 60118, A = e ? Symbol.for("react.scope") : 60119;
  function O(d) {
    if (typeof d == "object" && d !== null) {
      var W = d.$$typeof;
      switch (W) {
        case r:
          switch (d = d.type, d) {
            case b:
            case l:
            case n:
            case a:
            case o:
            case s:
              return d;
            default:
              switch (d = d && d.$$typeof, d) {
                case i:
                case v:
                case S:
                case E:
                case u:
                  return d;
                default:
                  return W;
              }
          }
        case t:
          return W;
      }
    }
  }
  function R(d) {
    return O(d) === l;
  }
  return L.AsyncMode = b, L.ConcurrentMode = l, L.ContextConsumer = i, L.ContextProvider = u, L.Element = r, L.ForwardRef = v, L.Fragment = n, L.Lazy = S, L.Memo = E, L.Portal = t, L.Profiler = a, L.StrictMode = o, L.Suspense = s, L.isAsyncMode = function(d) {
    return R(d) || O(d) === b;
  }, L.isConcurrentMode = R, L.isContextConsumer = function(d) {
    return O(d) === i;
  }, L.isContextProvider = function(d) {
    return O(d) === u;
  }, L.isElement = function(d) {
    return typeof d == "object" && d !== null && d.$$typeof === r;
  }, L.isForwardRef = function(d) {
    return O(d) === v;
  }, L.isFragment = function(d) {
    return O(d) === n;
  }, L.isLazy = function(d) {
    return O(d) === S;
  }, L.isMemo = function(d) {
    return O(d) === E;
  }, L.isPortal = function(d) {
    return O(d) === t;
  }, L.isProfiler = function(d) {
    return O(d) === a;
  }, L.isStrictMode = function(d) {
    return O(d) === o;
  }, L.isSuspense = function(d) {
    return O(d) === s;
  }, L.isValidElementType = function(d) {
    return typeof d == "string" || typeof d == "function" || d === n || d === l || d === a || d === o || d === s || d === m || typeof d == "object" && d !== null && (d.$$typeof === S || d.$$typeof === E || d.$$typeof === u || d.$$typeof === i || d.$$typeof === v || d.$$typeof === y || d.$$typeof === g || d.$$typeof === A || d.$$typeof === c);
  }, L.typeOf = O, L;
}
var N = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Cr;
function Vt() {
  return Cr || (Cr = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, t = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, u = e ? Symbol.for("react.provider") : 60109, i = e ? Symbol.for("react.context") : 60110, b = e ? Symbol.for("react.async_mode") : 60111, l = e ? Symbol.for("react.concurrent_mode") : 60111, v = e ? Symbol.for("react.forward_ref") : 60112, s = e ? Symbol.for("react.suspense") : 60113, m = e ? Symbol.for("react.suspense_list") : 60120, E = e ? Symbol.for("react.memo") : 60115, S = e ? Symbol.for("react.lazy") : 60116, c = e ? Symbol.for("react.block") : 60121, y = e ? Symbol.for("react.fundamental") : 60117, g = e ? Symbol.for("react.responder") : 60118, A = e ? Symbol.for("react.scope") : 60119;
    function O(p) {
      return typeof p == "string" || typeof p == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      p === n || p === l || p === a || p === o || p === s || p === m || typeof p == "object" && p !== null && (p.$$typeof === S || p.$$typeof === E || p.$$typeof === u || p.$$typeof === i || p.$$typeof === v || p.$$typeof === y || p.$$typeof === g || p.$$typeof === A || p.$$typeof === c);
    }
    function R(p) {
      if (typeof p == "object" && p !== null) {
        var q = p.$$typeof;
        switch (q) {
          case r:
            var ue = p.type;
            switch (ue) {
              case b:
              case l:
              case n:
              case a:
              case o:
              case s:
                return ue;
              default:
                var Oe = ue && ue.$$typeof;
                switch (Oe) {
                  case i:
                  case v:
                  case S:
                  case E:
                  case u:
                    return Oe;
                  default:
                    return q;
                }
            }
          case t:
            return q;
        }
      }
    }
    var d = b, W = l, B = i, Y = u, V = r, re = v, J = n, Q = S, X = E, H = t, ee = a, z = o, Z = s, ae = !1;
    function ie(p) {
      return ae || (ae = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), f(p) || R(p) === b;
    }
    function f(p) {
      return R(p) === l;
    }
    function w(p) {
      return R(p) === i;
    }
    function P(p) {
      return R(p) === u;
    }
    function C(p) {
      return typeof p == "object" && p !== null && p.$$typeof === r;
    }
    function T(p) {
      return R(p) === v;
    }
    function F(p) {
      return R(p) === n;
    }
    function _(p) {
      return R(p) === S;
    }
    function x(p) {
      return R(p) === E;
    }
    function I(p) {
      return R(p) === t;
    }
    function M(p) {
      return R(p) === a;
    }
    function k(p) {
      return R(p) === o;
    }
    function j(p) {
      return R(p) === s;
    }
    N.AsyncMode = d, N.ConcurrentMode = W, N.ContextConsumer = B, N.ContextProvider = Y, N.Element = V, N.ForwardRef = re, N.Fragment = J, N.Lazy = Q, N.Memo = X, N.Portal = H, N.Profiler = ee, N.StrictMode = z, N.Suspense = Z, N.isAsyncMode = ie, N.isConcurrentMode = f, N.isContextConsumer = w, N.isContextProvider = P, N.isElement = C, N.isForwardRef = T, N.isFragment = F, N.isLazy = _, N.isMemo = x, N.isPortal = I, N.isProfiler = M, N.isStrictMode = k, N.isSuspense = j, N.isValidElementType = O, N.typeOf = R;
  }()), N;
}
var Pr;
function Zr() {
  return Pr || (Pr = 1, process.env.NODE_ENV === "production" ? Ce.exports = Ht() : Ce.exports = Vt()), Ce.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var We, _r;
function Gt() {
  if (_r) return We;
  _r = 1;
  var e = Object.getOwnPropertySymbols, r = Object.prototype.hasOwnProperty, t = Object.prototype.propertyIsEnumerable;
  function n(a) {
    if (a == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(a);
  }
  function o() {
    try {
      if (!Object.assign)
        return !1;
      var a = new String("abc");
      if (a[5] = "de", Object.getOwnPropertyNames(a)[0] === "5")
        return !1;
      for (var u = {}, i = 0; i < 10; i++)
        u["_" + String.fromCharCode(i)] = i;
      var b = Object.getOwnPropertyNames(u).map(function(v) {
        return u[v];
      });
      if (b.join("") !== "0123456789")
        return !1;
      var l = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(v) {
        l[v] = v;
      }), Object.keys(Object.assign({}, l)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return We = o() ? Object.assign : function(a, u) {
    for (var i, b = n(a), l, v = 1; v < arguments.length; v++) {
      i = Object(arguments[v]);
      for (var s in i)
        r.call(i, s) && (b[s] = i[s]);
      if (e) {
        l = e(i);
        for (var m = 0; m < l.length; m++)
          t.call(i, l[m]) && (b[l[m]] = i[l[m]]);
      }
    }
    return b;
  }, We;
}
var je, xr;
function cr() {
  if (xr) return je;
  xr = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return je = e, je;
}
var $e, Rr;
function Kr() {
  return Rr || (Rr = 1, $e = Function.call.bind(Object.prototype.hasOwnProperty)), $e;
}
var Be, Ar;
function Xt() {
  if (Ar) return Be;
  Ar = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var r = cr(), t = {}, n = Kr();
    e = function(a) {
      var u = "Warning: " + a;
      typeof console < "u" && console.error(u);
      try {
        throw new Error(u);
      } catch {
      }
    };
  }
  function o(a, u, i, b, l) {
    if (process.env.NODE_ENV !== "production") {
      for (var v in a)
        if (n(a, v)) {
          var s;
          try {
            if (typeof a[v] != "function") {
              var m = Error(
                (b || "React class") + ": " + i + " type `" + v + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof a[v] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw m.name = "Invariant Violation", m;
            }
            s = a[v](u, v, b, i, null, r);
          } catch (S) {
            s = S;
          }
          if (s && !(s instanceof Error) && e(
            (b || "React class") + ": type specification of " + i + " `" + v + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof s + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), s instanceof Error && !(s.message in t)) {
            t[s.message] = !0;
            var E = l ? l() : "";
            e(
              "Failed " + i + " type: " + s.message + (E ?? "")
            );
          }
        }
    }
  }
  return o.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (t = {});
  }, Be = o, Be;
}
var ze, Fr;
function Zt() {
  if (Fr) return ze;
  Fr = 1;
  var e = Zr(), r = Gt(), t = cr(), n = Kr(), o = Xt(), a = function() {
  };
  process.env.NODE_ENV !== "production" && (a = function(i) {
    var b = "Warning: " + i;
    typeof console < "u" && console.error(b);
    try {
      throw new Error(b);
    } catch {
    }
  });
  function u() {
    return null;
  }
  return ze = function(i, b) {
    var l = typeof Symbol == "function" && Symbol.iterator, v = "@@iterator";
    function s(f) {
      var w = f && (l && f[l] || f[v]);
      if (typeof w == "function")
        return w;
    }
    var m = "<<anonymous>>", E = {
      array: g("array"),
      bigint: g("bigint"),
      bool: g("boolean"),
      func: g("function"),
      number: g("number"),
      object: g("object"),
      string: g("string"),
      symbol: g("symbol"),
      any: A(),
      arrayOf: O,
      element: R(),
      elementType: d(),
      instanceOf: W,
      node: re(),
      objectOf: Y,
      oneOf: B,
      oneOfType: V,
      shape: Q,
      exact: X
    };
    function S(f, w) {
      return f === w ? f !== 0 || 1 / f === 1 / w : f !== f && w !== w;
    }
    function c(f, w) {
      this.message = f, this.data = w && typeof w == "object" ? w : {}, this.stack = "";
    }
    c.prototype = Error.prototype;
    function y(f) {
      if (process.env.NODE_ENV !== "production")
        var w = {}, P = 0;
      function C(F, _, x, I, M, k, j) {
        if (I = I || m, k = k || x, j !== t) {
          if (b) {
            var p = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw p.name = "Invariant Violation", p;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var q = I + ":" + x;
            !w[q] && // Avoid spamming the console because they are often not actionable except for lib authors
            P < 3 && (a(
              "You are manually calling a React.PropTypes validation function for the `" + k + "` prop on `" + I + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), w[q] = !0, P++);
          }
        }
        return _[x] == null ? F ? _[x] === null ? new c("The " + M + " `" + k + "` is marked as required " + ("in `" + I + "`, but its value is `null`.")) : new c("The " + M + " `" + k + "` is marked as required in " + ("`" + I + "`, but its value is `undefined`.")) : null : f(_, x, I, M, k);
      }
      var T = C.bind(null, !1);
      return T.isRequired = C.bind(null, !0), T;
    }
    function g(f) {
      function w(P, C, T, F, _, x) {
        var I = P[C], M = z(I);
        if (M !== f) {
          var k = Z(I);
          return new c(
            "Invalid " + F + " `" + _ + "` of type " + ("`" + k + "` supplied to `" + T + "`, expected ") + ("`" + f + "`."),
            { expectedType: f }
          );
        }
        return null;
      }
      return y(w);
    }
    function A() {
      return y(u);
    }
    function O(f) {
      function w(P, C, T, F, _) {
        if (typeof f != "function")
          return new c("Property `" + _ + "` of component `" + T + "` has invalid PropType notation inside arrayOf.");
        var x = P[C];
        if (!Array.isArray(x)) {
          var I = z(x);
          return new c("Invalid " + F + " `" + _ + "` of type " + ("`" + I + "` supplied to `" + T + "`, expected an array."));
        }
        for (var M = 0; M < x.length; M++) {
          var k = f(x, M, T, F, _ + "[" + M + "]", t);
          if (k instanceof Error)
            return k;
        }
        return null;
      }
      return y(w);
    }
    function R() {
      function f(w, P, C, T, F) {
        var _ = w[P];
        if (!i(_)) {
          var x = z(_);
          return new c("Invalid " + T + " `" + F + "` of type " + ("`" + x + "` supplied to `" + C + "`, expected a single ReactElement."));
        }
        return null;
      }
      return y(f);
    }
    function d() {
      function f(w, P, C, T, F) {
        var _ = w[P];
        if (!e.isValidElementType(_)) {
          var x = z(_);
          return new c("Invalid " + T + " `" + F + "` of type " + ("`" + x + "` supplied to `" + C + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return y(f);
    }
    function W(f) {
      function w(P, C, T, F, _) {
        if (!(P[C] instanceof f)) {
          var x = f.name || m, I = ie(P[C]);
          return new c("Invalid " + F + " `" + _ + "` of type " + ("`" + I + "` supplied to `" + T + "`, expected ") + ("instance of `" + x + "`."));
        }
        return null;
      }
      return y(w);
    }
    function B(f) {
      if (!Array.isArray(f))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? a(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : a("Invalid argument supplied to oneOf, expected an array.")), u;
      function w(P, C, T, F, _) {
        for (var x = P[C], I = 0; I < f.length; I++)
          if (S(x, f[I]))
            return null;
        var M = JSON.stringify(f, function(j, p) {
          var q = Z(p);
          return q === "symbol" ? String(p) : p;
        });
        return new c("Invalid " + F + " `" + _ + "` of value `" + String(x) + "` " + ("supplied to `" + T + "`, expected one of " + M + "."));
      }
      return y(w);
    }
    function Y(f) {
      function w(P, C, T, F, _) {
        if (typeof f != "function")
          return new c("Property `" + _ + "` of component `" + T + "` has invalid PropType notation inside objectOf.");
        var x = P[C], I = z(x);
        if (I !== "object")
          return new c("Invalid " + F + " `" + _ + "` of type " + ("`" + I + "` supplied to `" + T + "`, expected an object."));
        for (var M in x)
          if (n(x, M)) {
            var k = f(x, M, T, F, _ + "." + M, t);
            if (k instanceof Error)
              return k;
          }
        return null;
      }
      return y(w);
    }
    function V(f) {
      if (!Array.isArray(f))
        return process.env.NODE_ENV !== "production" && a("Invalid argument supplied to oneOfType, expected an instance of array."), u;
      for (var w = 0; w < f.length; w++) {
        var P = f[w];
        if (typeof P != "function")
          return a(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + ae(P) + " at index " + w + "."
          ), u;
      }
      function C(T, F, _, x, I) {
        for (var M = [], k = 0; k < f.length; k++) {
          var j = f[k], p = j(T, F, _, x, I, t);
          if (p == null)
            return null;
          p.data && n(p.data, "expectedType") && M.push(p.data.expectedType);
        }
        var q = M.length > 0 ? ", expected one of type [" + M.join(", ") + "]" : "";
        return new c("Invalid " + x + " `" + I + "` supplied to " + ("`" + _ + "`" + q + "."));
      }
      return y(C);
    }
    function re() {
      function f(w, P, C, T, F) {
        return H(w[P]) ? null : new c("Invalid " + T + " `" + F + "` supplied to " + ("`" + C + "`, expected a ReactNode."));
      }
      return y(f);
    }
    function J(f, w, P, C, T) {
      return new c(
        (f || "React class") + ": " + w + " type `" + P + "." + C + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + T + "`."
      );
    }
    function Q(f) {
      function w(P, C, T, F, _) {
        var x = P[C], I = z(x);
        if (I !== "object")
          return new c("Invalid " + F + " `" + _ + "` of type `" + I + "` " + ("supplied to `" + T + "`, expected `object`."));
        for (var M in f) {
          var k = f[M];
          if (typeof k != "function")
            return J(T, F, _, M, Z(k));
          var j = k(x, M, T, F, _ + "." + M, t);
          if (j)
            return j;
        }
        return null;
      }
      return y(w);
    }
    function X(f) {
      function w(P, C, T, F, _) {
        var x = P[C], I = z(x);
        if (I !== "object")
          return new c("Invalid " + F + " `" + _ + "` of type `" + I + "` " + ("supplied to `" + T + "`, expected `object`."));
        var M = r({}, P[C], f);
        for (var k in M) {
          var j = f[k];
          if (n(f, k) && typeof j != "function")
            return J(T, F, _, k, Z(j));
          if (!j)
            return new c(
              "Invalid " + F + " `" + _ + "` key `" + k + "` supplied to `" + T + "`.\nBad object: " + JSON.stringify(P[C], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(f), null, "  ")
            );
          var p = j(x, k, T, F, _ + "." + k, t);
          if (p)
            return p;
        }
        return null;
      }
      return y(w);
    }
    function H(f) {
      switch (typeof f) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !f;
        case "object":
          if (Array.isArray(f))
            return f.every(H);
          if (f === null || i(f))
            return !0;
          var w = s(f);
          if (w) {
            var P = w.call(f), C;
            if (w !== f.entries) {
              for (; !(C = P.next()).done; )
                if (!H(C.value))
                  return !1;
            } else
              for (; !(C = P.next()).done; ) {
                var T = C.value;
                if (T && !H(T[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function ee(f, w) {
      return f === "symbol" ? !0 : w ? w["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && w instanceof Symbol : !1;
    }
    function z(f) {
      var w = typeof f;
      return Array.isArray(f) ? "array" : f instanceof RegExp ? "object" : ee(w, f) ? "symbol" : w;
    }
    function Z(f) {
      if (typeof f > "u" || f === null)
        return "" + f;
      var w = z(f);
      if (w === "object") {
        if (f instanceof Date)
          return "date";
        if (f instanceof RegExp)
          return "regexp";
      }
      return w;
    }
    function ae(f) {
      var w = Z(f);
      switch (w) {
        case "array":
        case "object":
          return "an " + w;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + w;
        default:
          return w;
      }
    }
    function ie(f) {
      return !f.constructor || !f.constructor.name ? m : f.constructor.name;
    }
    return E.checkPropTypes = o, E.resetWarningCache = o.resetWarningCache, E.PropTypes = E, E;
  }, ze;
}
var qe, Ir;
function Kt() {
  if (Ir) return qe;
  Ir = 1;
  var e = cr();
  function r() {
  }
  function t() {
  }
  return t.resetWarningCache = r, qe = function() {
    function n(u, i, b, l, v, s) {
      if (s !== e) {
        var m = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw m.name = "Invariant Violation", m;
      }
    }
    n.isRequired = n;
    function o() {
      return n;
    }
    var a = {
      array: n,
      bigint: n,
      bool: n,
      func: n,
      number: n,
      object: n,
      string: n,
      symbol: n,
      any: n,
      arrayOf: o,
      element: n,
      elementType: n,
      instanceOf: o,
      node: n,
      objectOf: o,
      oneOf: o,
      oneOfType: o,
      shape: o,
      exact: o,
      checkPropTypes: t,
      resetWarningCache: r
    };
    return a.PropTypes = a, a;
  }, qe;
}
if (process.env.NODE_ENV !== "production") {
  var Jt = Zr(), Qt = !0;
  Ke.exports = Zt()(Jt.isElement, Qt);
} else
  Ke.exports = Kt()();
var D = Ke.exports;
const Jr = /* @__PURE__ */ jt(D);
var Je = "data-focus-lock", Qr = "data-focus-lock-disabled", en = "data-no-focus-lock", rn = "data-autofocus-inside", tn = "data-no-autofocus", Ye = {
  width: "1px",
  height: "0px",
  padding: 0,
  overflow: "hidden",
  position: "fixed",
  top: "1px",
  left: "1px"
};
process.env.NODE_ENV !== "production" && Jr.node;
var et = or({}, function(e) {
  var r = e.target, t = e.currentTarget;
  return {
    target: r,
    currentTarget: t
  };
}), rt = or(), nn = or(), tt = ar({
  async: !0,
  ssr: typeof document < "u"
}), on = /* @__PURE__ */ It(void 0), an = [], nt = /* @__PURE__ */ h.forwardRef(function(r, t) {
  var n, o = h.useState(), a = o[0], u = o[1], i = h.useRef(), b = h.useRef(!1), l = h.useRef(null), v = h.useState({}), s = v[1], m = r.children, E = r.disabled, S = E === void 0 ? !1 : E, c = r.noFocusGuards, y = c === void 0 ? !1 : c, g = r.persistentFocus, A = g === void 0 ? !1 : g, O = r.crossFrame, R = O === void 0 ? !0 : O, d = r.autoFocus, W = d === void 0 ? !0 : d, B = r.allowTextSelection, Y = r.group, V = r.className, re = r.whiteList, J = r.hasPositiveIndices, Q = r.shards, X = Q === void 0 ? an : Q, H = r.as, ee = H === void 0 ? "div" : H, z = r.lockProps, Z = z === void 0 ? {} : z, ae = r.sideCar, ie = r.returnFocus, f = ie === void 0 ? !1 : ie, w = r.focusOptions, P = r.onActivation, C = r.onDeactivation, T = h.useState({}), F = T[0], _ = h.useCallback(function(K) {
    var ce = K.captureFocusRestore;
    if (!l.current) {
      var se, te = (se = document) == null ? void 0 : se.activeElement;
      l.current = te, te !== document.body && (l.current = ce(te));
    }
    i.current && P && P(i.current), b.current = !0, s();
  }, [P]), x = h.useCallback(function() {
    b.current = !1, C && C(i.current), s();
  }, [C]), I = h.useCallback(function(K) {
    var ce = l.current;
    if (ce) {
      var se = (typeof ce == "function" ? ce() : ce) || document.body, te = typeof f == "function" ? f(se) : f;
      if (te) {
        var Er = typeof te == "object" ? te : void 0;
        l.current = null, K ? Promise.resolve().then(function() {
          return se.focus(Er);
        }) : se.focus(Er);
      }
    }
  }, [f]), M = h.useCallback(function(K) {
    b.current && et.useMedium(K);
  }, []), k = rt.useMedium, j = h.useCallback(function(K) {
    i.current !== K && (i.current = K, u(K));
  }, []);
  process.env.NODE_ENV !== "production" && (typeof B < "u" && console.warn("React-Focus-Lock: allowTextSelection is deprecated and enabled by default"), h.useEffect(function() {
    !i.current && typeof ee != "string" && console.error("FocusLock: could not obtain ref to internal node");
  }, []));
  var p = ke((n = {}, n[Qr] = S && "disabled", n[Je] = Y, n), Z), q = y !== !0, ue = q && y !== "tail", Oe = Ur([t, j]), xt = h.useMemo(function() {
    return {
      observed: i,
      shards: X,
      enabled: !S,
      active: b.current
    };
  }, [S, b.current, X, a]);
  return /* @__PURE__ */ h.createElement(h.Fragment, null, q && [
    /* @__PURE__ */ h.createElement("div", {
      key: "guard-first",
      "data-focus-guard": !0,
      tabIndex: S ? -1 : 0,
      style: Ye
    }),
    J ? /* @__PURE__ */ h.createElement("div", {
      key: "guard-nearest",
      "data-focus-guard": !0,
      tabIndex: S ? -1 : 1,
      style: Ye
    }) : null
  ], !S && /* @__PURE__ */ h.createElement(ae, {
    id: F,
    sideCar: tt,
    observed: a,
    disabled: S,
    persistentFocus: A,
    crossFrame: R,
    autoFocus: W,
    whiteList: re,
    shards: X,
    onActivation: _,
    onDeactivation: x,
    returnFocus: I,
    focusOptions: w
  }), /* @__PURE__ */ h.createElement(ee, ke({
    ref: Oe
  }, p, {
    className: V,
    onBlur: k,
    onFocus: M
  }), /* @__PURE__ */ h.createElement(on.Provider, {
    value: xt
  }, m)), ue && /* @__PURE__ */ h.createElement("div", {
    "data-focus-guard": !0,
    tabIndex: S ? -1 : 0,
    style: Ye
  }));
});
nt.propTypes = process.env.NODE_ENV !== "production" ? {
  children: D.node,
  disabled: D.bool,
  returnFocus: D.oneOfType([D.bool, D.object, D.func]),
  focusOptions: D.object,
  noFocusGuards: D.bool,
  hasPositiveIndices: D.bool,
  allowTextSelection: D.bool,
  autoFocus: D.bool,
  persistentFocus: D.bool,
  crossFrame: D.bool,
  group: D.string,
  className: D.string,
  whiteList: D.func,
  shards: D.arrayOf(D.any),
  as: D.oneOfType([D.string, D.func, D.object]),
  lockProps: D.object,
  onActivation: D.func,
  onDeactivation: D.func,
  sideCar: D.any.isRequired
} : {};
function sr(e) {
  setTimeout(e, 1);
}
var un = function(r) {
  return r && "current" in r ? r.current : r;
}, ot = ar(), at = "data-focus-on-hidden", cn = { preventScroll: !0 }, sn = h.forwardRef(function(e, r) {
  var t = h.useState(!1), n = t[0], o = t[1], a = e.children, u = e.autoFocus, i = e.shards, b = e.crossFrame, l = e.enabled, v = l === void 0 ? !0 : l, s = e.scrollLock, m = s === void 0 ? !0 : s, E = e.focusLock, S = E === void 0 ? !0 : E, c = e.returnFocus, y = c === void 0 ? !0 : c, g = e.inert, A = e.allowPinchZoom, O = e.sideCar, R = e.className, d = e.shouldIgnore, W = e.preventScrollOnFocus, B = e.style, Y = e.as, V = e.gapMode, re = Ie(e, ["children", "autoFocus", "shards", "crossFrame", "enabled", "scrollLock", "focusLock", "returnFocus", "inert", "allowPinchZoom", "sideCar", "className", "shouldIgnore", "preventScrollOnFocus", "style", "as", "gapMode"]), J = O, Q = n.onActivation, X = n.onDeactivation, H = Ie(n, ["onActivation", "onDeactivation"]), ee = $($({}, H), {
    as: Y,
    style: B,
    sideCar: O,
    shards: i,
    allowPinchZoom: A,
    gapMode: V,
    inert: g,
    enabled: v && m
  });
  return h.createElement(
    h.Fragment,
    null,
    h.createElement(nt, { ref: r, sideCar: O, disabled: !(n && v && S), returnFocus: y, autoFocus: u, shards: i, crossFrame: b, onActivation: Q, onDeactivation: X, className: R, whiteList: d, lockProps: ee, focusOptions: W ? cn : void 0, as: ur }, a),
    v && h.createElement(J, $({}, re, { sideCar: ot, setLockProps: o, shards: i }))
  );
});
function Qe(e, r) {
  return Qe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, n) {
    return t.__proto__ = n, t;
  }, Qe(e, r);
}
function fn(e, r) {
  e.prototype = Object.create(r.prototype), e.prototype.constructor = e, Qe(e, r);
}
function Ee(e) {
  "@babel/helpers - typeof";
  return Ee = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, Ee(e);
}
function ln(e, r) {
  if (Ee(e) != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var n = t.call(e, r || "default");
    if (Ee(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(e);
}
function dn(e) {
  var r = ln(e, "string");
  return Ee(r) == "symbol" ? r : r + "";
}
function vn(e, r, t) {
  return (r = dn(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function mn(e, r) {
  if (process.env.NODE_ENV !== "production") {
    if (typeof e != "function")
      throw new Error("Expected reducePropsToState to be a function.");
    if (typeof r != "function")
      throw new Error("Expected handleStateChangeOnClient to be a function.");
  }
  function t(n) {
    return n.displayName || n.name || "Component";
  }
  return function(o) {
    if (process.env.NODE_ENV !== "production" && typeof o != "function")
      throw new Error("Expected WrappedComponent to be a React component.");
    var a = [], u;
    function i() {
      u = e(a.map(function(l) {
        return l.props;
      })), r(u);
    }
    var b = /* @__PURE__ */ function(l) {
      fn(v, l);
      function v() {
        return l.apply(this, arguments) || this;
      }
      v.peek = function() {
        return u;
      };
      var s = v.prototype;
      return s.componentDidMount = function() {
        a.push(this), i();
      }, s.componentDidUpdate = function() {
        i();
      }, s.componentWillUnmount = function() {
        var E = a.indexOf(this);
        a.splice(E, 1), i();
      }, s.render = function() {
        return /* @__PURE__ */ Ft.createElement(o, this.props);
      }, v;
    }(kt);
    return vn(b, "displayName", "SideEffect(" + t(o) + ")"), b;
  };
}
var G = function(e) {
  for (var r = Array(e.length), t = 0; t < e.length; ++t)
    r[t] = e[t];
  return r;
}, oe = function(e) {
  return Array.isArray(e) ? e : [e];
}, it = function(e) {
  return Array.isArray(e) ? e[0] : e;
}, pn = function(e) {
  if (e.nodeType !== Node.ELEMENT_NODE)
    return !1;
  var r = window.getComputedStyle(e, null);
  return !r || !r.getPropertyValue ? !1 : r.getPropertyValue("display") === "none" || r.getPropertyValue("visibility") === "hidden";
}, ut = function(e) {
  return e.parentNode && e.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    e.parentNode.host
  ) : e.parentNode;
}, ct = function(e) {
  return e === document || e && e.nodeType === Node.DOCUMENT_NODE;
}, hn = function(e) {
  return e.hasAttribute("inert");
}, yn = function(e, r) {
  return !e || ct(e) || !pn(e) && !hn(e) && r(ut(e));
}, st = function(e, r) {
  var t = e.get(r);
  if (t !== void 0)
    return t;
  var n = yn(r, st.bind(void 0, e));
  return e.set(r, n), n;
}, bn = function(e, r) {
  return e && !ct(e) ? Sn(e) ? r(ut(e)) : !1 : !0;
}, ft = function(e, r) {
  var t = e.get(r);
  if (t !== void 0)
    return t;
  var n = bn(r, ft.bind(void 0, e));
  return e.set(r, n), n;
}, lt = function(e) {
  return e.dataset;
}, gn = function(e) {
  return e.tagName === "BUTTON";
}, dt = function(e) {
  return e.tagName === "INPUT";
}, vt = function(e) {
  return dt(e) && e.type === "radio";
}, En = function(e) {
  return !((dt(e) || gn(e)) && (e.type === "hidden" || e.disabled));
}, Sn = function(e) {
  var r = e.getAttribute(tn);
  return ![!0, "true", ""].includes(r);
}, fr = function(e) {
  var r;
  return !!(e && (!((r = lt(e)) === null || r === void 0) && r.focusGuard));
}, er = function(e) {
  return !fr(e);
}, wn = function(e) {
  return !!e;
}, On = function(e, r) {
  var t = Math.max(0, e.tabIndex), n = Math.max(0, r.tabIndex), o = t - n, a = e.index - r.index;
  if (o) {
    if (!t)
      return 1;
    if (!n)
      return -1;
  }
  return o || a;
}, Tn = function(e) {
  return e.tabIndex < 0 && !e.hasAttribute("tabindex") ? 0 : e.tabIndex;
}, lr = function(e, r, t) {
  return G(e).map(function(n, o) {
    var a = Tn(n);
    return {
      node: n,
      index: o,
      tabIndex: t && a === -1 ? (n.dataset || {}).focusGuard ? 0 : -1 : a
    };
  }).filter(function(n) {
    return !r || n.tabIndex >= 0;
  }).sort(On);
}, Cn = [
  "button:enabled",
  "select:enabled",
  "textarea:enabled",
  "input:enabled",
  // elements with explicit roles will also use explicit tabindex
  // '[role="button"]',
  "a[href]",
  "area[href]",
  "summary",
  "iframe",
  "object",
  "embed",
  "audio[controls]",
  "video[controls]",
  "[tabindex]",
  "[contenteditable]",
  "[autofocus]"
], dr = Cn.join(","), Pn = "".concat(dr, ", [data-focus-guard]"), mt = function(e, r) {
  return G((e.shadowRoot || e).children).reduce(function(t, n) {
    return t.concat(n.matches(r ? Pn : dr) ? [n] : [], mt(n));
  }, []);
}, _n = function(e, r) {
  var t;
  return e instanceof HTMLIFrameElement && (!((t = e.contentDocument) === null || t === void 0) && t.body) ? ye([e.contentDocument.body], r) : [e];
}, ye = function(e, r) {
  return e.reduce(function(t, n) {
    var o, a = mt(n, r), u = (o = []).concat.apply(o, a.map(function(i) {
      return _n(i, r);
    }));
    return t.concat(
      // add all tabbables inside and within shadow DOMs in DOM order
      u,
      // add if node is tabbable itself
      n.parentNode ? G(n.parentNode.querySelectorAll(dr)).filter(function(i) {
        return i === n;
      }) : []
    );
  }, []);
}, xn = function(e) {
  var r = e.querySelectorAll("[".concat(rn, "]"));
  return G(r).map(function(t) {
    return ye([t]);
  }).reduce(function(t, n) {
    return t.concat(n);
  }, []);
}, vr = function(e, r) {
  return G(e).filter(function(t) {
    return st(r, t);
  }).filter(function(t) {
    return En(t);
  });
}, kr = function(e, r) {
  return r === void 0 && (r = /* @__PURE__ */ new Map()), G(e).filter(function(t) {
    return ft(r, t);
  });
}, mr = function(e, r, t) {
  return lr(vr(ye(e, t), r), !0, t);
}, Me = function(e, r) {
  return lr(vr(ye(e), r), !1);
}, Rn = function(e, r) {
  return vr(xn(e), r);
}, ne = function(e, r) {
  return e.shadowRoot ? ne(e.shadowRoot, r) : Object.getPrototypeOf(e).contains !== void 0 && Object.getPrototypeOf(e).contains.call(e, r) ? !0 : G(e.children).some(function(t) {
    var n;
    if (t instanceof HTMLIFrameElement) {
      var o = (n = t.contentDocument) === null || n === void 0 ? void 0 : n.body;
      return o ? ne(o, r) : !1;
    }
    return ne(t, r);
  });
}, An = function(e) {
  for (var r = /* @__PURE__ */ new Set(), t = e.length, n = 0; n < t; n += 1)
    for (var o = n + 1; o < t; o += 1) {
      var a = e[n].compareDocumentPosition(e[o]);
      (a & Node.DOCUMENT_POSITION_CONTAINED_BY) > 0 && r.add(o), (a & Node.DOCUMENT_POSITION_CONTAINS) > 0 && r.add(n);
    }
  return e.filter(function(u, i) {
    return !r.has(i);
  });
}, pt = function(e) {
  return e.parentNode ? pt(e.parentNode) : e;
}, pr = function(e) {
  var r = oe(e);
  return r.filter(Boolean).reduce(function(t, n) {
    var o = n.getAttribute(Je);
    return t.push.apply(t, o ? An(G(pt(n).querySelectorAll("[".concat(Je, '="').concat(o, '"]:not([').concat(Qr, '="disabled"])')))) : [n]), t;
  }, []);
}, Fn = function(e) {
  try {
    return e();
  } catch {
    return;
  }
}, Se = function(e) {
  if (e === void 0 && (e = document), !(!e || !e.activeElement)) {
    var r = e.activeElement;
    return r.shadowRoot ? Se(r.shadowRoot) : r instanceof HTMLIFrameElement && Fn(function() {
      return r.contentWindow.document;
    }) ? Se(r.contentWindow.document) : r;
  }
}, In = function(e, r) {
  return e === r;
}, kn = function(e, r) {
  return !!G(e.querySelectorAll("iframe")).some(function(t) {
    return In(t, r);
  });
}, ht = function(e, r) {
  return r === void 0 && (r = Se(it(e).ownerDocument)), !r || r.dataset && r.dataset.focusGuard ? !1 : pr(e).some(function(t) {
    return ne(t, r) || kn(t, r);
  });
}, Mn = function(e) {
  e === void 0 && (e = document);
  var r = Se(e);
  return r ? G(e.querySelectorAll("[".concat(en, "]"))).some(function(t) {
    return ne(t, r);
  }) : !1;
}, Ln = function(e, r) {
  return r.filter(vt).filter(function(t) {
    return t.name === e.name;
  }).filter(function(t) {
    return t.checked;
  })[0] || e;
}, hr = function(e, r) {
  return vt(e) && e.name ? Ln(e, r) : e;
}, Nn = function(e) {
  var r = /* @__PURE__ */ new Set();
  return e.forEach(function(t) {
    return r.add(hr(t, e));
  }), e.filter(function(t) {
    return r.has(t);
  });
}, Mr = function(e) {
  return e[0] && e.length > 1 ? hr(e[0], e) : e[0];
}, Lr = function(e, r) {
  return e.indexOf(hr(r, e));
}, rr = "NEW_FOCUS", Dn = function(e, r, t, n, o) {
  var a = e.length, u = e[0], i = e[a - 1], b = fr(n);
  if (!(n && e.indexOf(n) >= 0)) {
    var l = n !== void 0 ? t.indexOf(n) : -1, v = o ? t.indexOf(o) : l, s = o ? e.indexOf(o) : -1;
    if (l === -1)
      return s !== -1 ? s : rr;
    if (s === -1)
      return rr;
    var m = l - v, E = t.indexOf(u), S = t.indexOf(i), c = Nn(t), y = n !== void 0 ? c.indexOf(n) : -1, g = y - (o ? c.indexOf(o) : l);
    if (!m && s >= 0 || r.length === 0)
      return s;
    var A = Lr(e, r[0]), O = Lr(e, r[r.length - 1]);
    if (l <= E && b && Math.abs(m) > 1)
      return O;
    if (l >= S && b && Math.abs(m) > 1)
      return A;
    if (m && Math.abs(g) > 1)
      return s;
    if (l <= E)
      return O;
    if (l > S)
      return A;
    if (m)
      return Math.abs(m) > 1 ? s : (a + s + m) % a;
  }
}, Wn = function(e) {
  return function(r) {
    var t, n = (t = lt(r)) === null || t === void 0 ? void 0 : t.autofocus;
    return (
      // @ts-expect-error
      r.autofocus || //
      n !== void 0 && n !== "false" || //
      e.indexOf(r) >= 0
    );
  };
}, Nr = function(e, r, t) {
  var n = e.map(function(a) {
    var u = a.node;
    return u;
  }), o = kr(n.filter(Wn(t)));
  return o && o.length ? Mr(o) : Mr(kr(r));
}, tr = function(e, r) {
  return r === void 0 && (r = []), r.push(e), e.parentNode && tr(e.parentNode.host || e.parentNode, r), r;
}, Ue = function(e, r) {
  for (var t = tr(e), n = tr(r), o = 0; o < t.length; o += 1) {
    var a = t[o];
    if (n.indexOf(a) >= 0)
      return a;
  }
  return !1;
}, yt = function(e, r, t) {
  var n = oe(e), o = oe(r), a = n[0], u = !1;
  return o.filter(Boolean).forEach(function(i) {
    u = Ue(u || i, i) || u, t.filter(Boolean).forEach(function(b) {
      var l = Ue(a, b);
      l && (!u || ne(l, u) ? u = l : u = Ue(l, u));
    });
  }), u;
}, Dr = function(e, r) {
  return e.reduce(function(t, n) {
    return t.concat(Rn(n, r));
  }, []);
}, jn = function(e, r) {
  var t = /* @__PURE__ */ new Map();
  return r.forEach(function(n) {
    return t.set(n.node, n);
  }), e.map(function(n) {
    return t.get(n);
  }).filter(wn);
}, $n = function(e, r) {
  var t = Se(oe(e).length > 0 ? document : it(e).ownerDocument), n = pr(e).filter(er), o = yt(t || e, e, n), a = /* @__PURE__ */ new Map(), u = Me(n, a), i = u.filter(function(S) {
    var c = S.node;
    return er(c);
  });
  if (i[0]) {
    var b = Me([o], a).map(function(S) {
      var c = S.node;
      return c;
    }), l = jn(b, i), v = l.map(function(S) {
      var c = S.node;
      return c;
    }), s = l.filter(function(S) {
      var c = S.tabIndex;
      return c >= 0;
    }).map(function(S) {
      var c = S.node;
      return c;
    }), m = Dn(v, s, b, t, r);
    if (m === rr) {
      var E = (
        // first try only tabbable, and the fallback to all focusable, as long as at least one element should be picked for focus
        Nr(u, s, Dr(n, a)) || Nr(u, v, Dr(n, a))
      );
      if (E)
        return { node: E };
      console.warn("focus-lock: cannot find any node to move focus into");
      return;
    }
    return m === void 0 ? m : l[m];
  }
}, Bn = function(e) {
  var r = pr(e).filter(er), t = yt(e, e, r), n = lr(ye([t], !0), !0, !0), o = ye(r, !1);
  return n.map(function(a) {
    var u = a.node, i = a.index;
    return {
      node: u,
      index: i,
      lockItem: o.indexOf(u) >= 0,
      guard: fr(u)
    };
  });
}, yr = function(e, r) {
  e && ("focus" in e && e.focus(r), "contentWindow" in e && e.contentWindow && e.contentWindow.focus());
}, He = 0, Ve = !1, bt = function(e, r, t) {
  t === void 0 && (t = {});
  var n = $n(e, r);
  if (!Ve && n) {
    if (He > 2) {
      console.error("FocusLock: focus-fighting detected. Only one focus management system could be active. See https://github.com/theKashey/focus-lock/#focus-fighting"), Ve = !0, setTimeout(function() {
        Ve = !1;
      }, 1);
      return;
    }
    He++, yr(n.node, t.focusOptions), He--;
  }
};
function ge(e) {
  if (!e)
    return null;
  if (typeof WeakRef > "u")
    return function() {
      return e || null;
    };
  var r = e ? new WeakRef(e) : null;
  return function() {
    return (r == null ? void 0 : r.deref()) || null;
  };
}
var zn = function(e) {
  if (!e)
    return null;
  for (var r = [], t = e; t && t !== document.body; )
    r.push({
      current: ge(t),
      parent: ge(t.parentElement),
      left: ge(t.previousElementSibling),
      right: ge(t.nextElementSibling)
    }), t = t.parentElement;
  return {
    element: ge(e),
    stack: r,
    ownerDocument: e.ownerDocument
  };
}, qn = function(e) {
  var r, t, n, o, a;
  if (e)
    for (var u = e.stack, i = e.ownerDocument, b = /* @__PURE__ */ new Map(), l = 0, v = u; l < v.length; l++) {
      var s = v[l], m = (r = s.parent) === null || r === void 0 ? void 0 : r.call(s);
      if (m && i.contains(m)) {
        for (var E = (t = s.left) === null || t === void 0 ? void 0 : t.call(s), S = s.current(), c = m.contains(S) ? S : void 0, y = (n = s.right) === null || n === void 0 ? void 0 : n.call(s), g = mr([m], b), A = (
          // that is element itself
          (a = (o = c ?? // or something in it's place
          (E == null ? void 0 : E.nextElementSibling)) !== null && o !== void 0 ? o : (
            // or somebody to the right, still close enough
            y
          )) !== null && a !== void 0 ? a : (
            // or somebody to the left, something?
            E
          )
        ); A; ) {
          for (var O = 0, R = g; O < R.length; O++) {
            var d = R[O];
            if (A != null && A.contains(d.node))
              return d.node;
          }
          A = A.nextElementSibling;
        }
        if (g.length)
          return g[0].node;
      }
    }
}, Yn = function(e) {
  var r = zn(e);
  return function() {
    return qn(r);
  };
}, Un = function(e, r, t) {
  if (!e || !r)
    return console.error("no element or scope given"), {};
  var n = oe(r);
  if (n.every(function(u) {
    return !ne(u, e);
  }))
    return console.error("Active element is not contained in the scope"), {};
  var o = t ? mr(n, /* @__PURE__ */ new Map()) : Me(n, /* @__PURE__ */ new Map()), a = o.findIndex(function(u) {
    var i = u.node;
    return i === e;
  });
  if (a !== -1)
    return {
      prev: o[a - 1],
      next: o[a + 1],
      first: o[0],
      last: o[o.length - 1]
    };
}, Hn = function(e, r) {
  var t = r ? mr(oe(e), /* @__PURE__ */ new Map()) : Me(oe(e), /* @__PURE__ */ new Map());
  return {
    first: t[0],
    last: t[t.length - 1]
  };
}, Vn = function(e) {
  return Object.assign({
    scope: document.body,
    cycle: !0,
    onlyTabbable: !0
  }, e);
}, gt = function(e, r, t) {
  r === void 0 && (r = {});
  var n = Vn(r), o = Un(e, n.scope, n.onlyTabbable);
  if (o) {
    var a = t(o, n.cycle);
    a && yr(a.node, n.focusOptions);
  }
}, Gn = function(e, r) {
  r === void 0 && (r = {}), gt(e, r, function(t, n) {
    var o = t.next, a = t.first;
    return o || n && a;
  });
}, Xn = function(e, r) {
  r === void 0 && (r = {}), gt(e, r, function(t, n) {
    var o = t.prev, a = t.last;
    return o || n && a;
  });
}, Et = function(e, r, t) {
  var n, o = Hn(e, (n = r.onlyTabbable) !== null && n !== void 0 ? n : !0), a = o[t];
  a && yr(a.node, r.focusOptions);
}, Zn = function(e, r) {
  r === void 0 && (r = {}), Et(e, r, "first");
}, Kn = function(e, r) {
  r === void 0 && (r = {}), Et(e, r, "last");
}, Jn = function() {
  return document && document.activeElement === document.body;
}, Qn = function() {
  return Jn() || Mn();
}, me = null, ve = null, pe = null, we = !1, eo = function() {
  return !0;
}, ro = function(r) {
  return (me.whiteList || eo)(r);
}, to = function(r, t) {
  pe = {
    observerNode: r,
    portaledElement: t
  };
}, no = function(r) {
  return pe && pe.portaledElement === r;
};
function Wr(e, r, t, n) {
  var o = null, a = e;
  do {
    var u = n[a];
    if (u.guard)
      u.node.dataset.focusAutoGuard && (o = u);
    else if (u.lockItem) {
      if (a !== e)
        return;
      o = null;
    } else
      break;
  } while ((a += t) !== r);
  o && (o.node.tabIndex = 0);
}
var oo = function(r) {
  return r ? !!we : we === "meanwhile";
}, ao = function e(r, t, n) {
  return t && (t.host === r && (!t.activeElement || n.contains(t.activeElement)) || t.parentNode && e(r, t.parentNode, n));
}, io = function(r, t) {
  return t.some(function(n) {
    return ao(r, n, n);
  });
}, Le = function() {
  var r = !1;
  if (me) {
    var t = me, n = t.observed, o = t.persistentFocus, a = t.autoFocus, u = t.shards, i = t.crossFrame, b = t.focusOptions, l = n || pe && pe.portaledElement, v = document && document.activeElement;
    if (l) {
      var s = [l].concat(u.map(un).filter(Boolean));
      if ((!v || ro(v)) && (o || oo(i) || !Qn() || !ve && a) && (l && !(ht(s) || v && io(v, s) || no(v)) && (document && !ve && v && !a ? (v.blur && v.blur(), document.body.focus()) : (r = bt(s, ve, {
        focusOptions: b
      }), pe = {})), we = !1, ve = document && document.activeElement), document && v !== document.activeElement && document.querySelector("[data-focus-auto-guard]")) {
        var m = document && document.activeElement, E = Bn(s), S = E.map(function(c) {
          var y = c.node;
          return y;
        }).indexOf(m);
        S > -1 && (E.filter(function(c) {
          var y = c.guard, g = c.node;
          return y && g.dataset.focusAutoGuard;
        }).forEach(function(c) {
          var y = c.node;
          return y.removeAttribute("tabIndex");
        }), Wr(S, E.length, 1, E), Wr(S, -1, -1, E));
      }
    }
  }
  return r;
}, St = function(r) {
  Le() && r && (r.stopPropagation(), r.preventDefault());
}, br = function() {
  return sr(Le);
}, uo = function(r) {
  var t = r.target, n = r.currentTarget;
  n.contains(t) || to(n, t);
}, co = function() {
  return null;
};
process.env.NODE_ENV !== "production" && Jr.node.isRequired;
var wt = function() {
  we = "just", sr(function() {
    we = "meanwhile";
  });
}, so = function() {
  document.addEventListener("focusin", St), document.addEventListener("focusout", br), window.addEventListener("blur", wt);
}, fo = function() {
  document.removeEventListener("focusin", St), document.removeEventListener("focusout", br), window.removeEventListener("blur", wt);
};
function lo(e) {
  return e.filter(function(r) {
    var t = r.disabled;
    return !t;
  });
}
var Ot = {
  moveFocusInside: bt,
  focusInside: ht,
  focusNextElement: Gn,
  focusPrevElement: Xn,
  focusFirstElement: Zn,
  focusLastElement: Kn,
  captureFocusRestore: Yn
};
function vo(e) {
  var r = e.slice(-1)[0];
  r && !me && so();
  var t = me, n = t && r && r.id === t.id;
  me = r, t && !n && (t.onDeactivation(), e.filter(function(o) {
    var a = o.id;
    return a === t.id;
  }).length || t.returnFocus(!r)), r ? (ve = null, (!n || t.observed !== r.observed) && r.onActivation(Ot), Le(), sr(Le)) : (fo(), ve = null);
}
et.assignSyncMedium(uo);
rt.assignMedium(br);
nn.assignMedium(function(e) {
  return e(Ot);
});
const mo = mn(lo, vo)(co);
ir(tt, mo);
var po = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function ho() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var r = po();
  return r && e.setAttribute("nonce", r), e;
}
function yo(e, r) {
  e.styleSheet ? e.styleSheet.cssText = r : e.appendChild(document.createTextNode(r));
}
function bo(e) {
  var r = document.head || document.getElementsByTagName("head")[0];
  r.appendChild(e);
}
var go = function() {
  var e = 0, r = null;
  return {
    add: function(t) {
      e == 0 && (r = ho()) && (yo(r, t), bo(r)), e++;
    },
    remove: function() {
      e--, !e && r && (r.parentNode && r.parentNode.removeChild(r), r = null);
    }
  };
}, Eo = function() {
  var e = go();
  return function(r, t) {
    h.useEffect(function() {
      return e.add(r), function() {
        e.remove();
      };
    }, [r && t]);
  };
}, gr = function() {
  var e = Eo(), r = function(t) {
    var n = t.styles, o = t.dynamic;
    return e(n, o), null;
  };
  return r;
}, So = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, Ge = function(e) {
  return parseInt(e || "", 10) || 0;
}, wo = function(e) {
  var r = window.getComputedStyle(document.body), t = r[e === "padding" ? "paddingLeft" : "marginLeft"], n = r[e === "padding" ? "paddingTop" : "marginTop"], o = r[e === "padding" ? "paddingRight" : "marginRight"];
  return [Ge(t), Ge(n), Ge(o)];
}, Oo = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return So;
  var r = wo(e), t = document.documentElement.clientWidth, n = window.innerWidth;
  return {
    left: r[0],
    top: r[1],
    right: r[2],
    gap: Math.max(0, n - t + r[2] - r[0])
  };
}, To = gr(), he = "data-scroll-locked", Co = function(e, r, t, n) {
  var o = e.left, a = e.top, u = e.right, i = e.gap;
  return t === void 0 && (t = "margin"), `
  .`.concat(zt, ` {
   overflow: hidden `).concat(n, `;
   padding-right: `).concat(i, "px ").concat(n, `;
  }
  body[`).concat(he, `] {
    overflow: hidden `).concat(n, `;
    overscroll-behavior: contain;
    `).concat([
    r && "position: relative ".concat(n, ";"),
    t === "margin" && `
    padding-left: `.concat(o, `px;
    padding-top: `).concat(a, `px;
    padding-right: `).concat(u, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(i, "px ").concat(n, `;
    `),
    t === "padding" && "padding-right: ".concat(i, "px ").concat(n, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(Ae, ` {
    right: `).concat(i, "px ").concat(n, `;
  }
  
  .`).concat(Fe, ` {
    margin-right: `).concat(i, "px ").concat(n, `;
  }
  
  .`).concat(Ae, " .").concat(Ae, ` {
    right: 0 `).concat(n, `;
  }
  
  .`).concat(Fe, " .").concat(Fe, ` {
    margin-right: 0 `).concat(n, `;
  }
  
  body[`).concat(he, `] {
    `).concat(qt, ": ").concat(i, `px;
  }
`);
}, jr = function() {
  var e = parseInt(document.body.getAttribute(he) || "0", 10);
  return isFinite(e) ? e : 0;
}, Po = function() {
  h.useEffect(function() {
    return document.body.setAttribute(he, (jr() + 1).toString()), function() {
      var e = jr() - 1;
      e <= 0 ? document.body.removeAttribute(he) : document.body.setAttribute(he, e.toString());
    };
  }, []);
}, _o = function(e) {
  var r = e.noRelative, t = e.noImportant, n = e.gapMode, o = n === void 0 ? "margin" : n;
  Po();
  var a = h.useMemo(function() {
    return Oo(o);
  }, [o]);
  return h.createElement(To, { styles: Co(a, !r, o, t ? "" : "!important") });
}, nr = !1;
if (typeof window < "u")
  try {
    var Pe = Object.defineProperty({}, "passive", {
      get: function() {
        return nr = !0, !0;
      }
    });
    window.addEventListener("test", Pe, Pe), window.removeEventListener("test", Pe, Pe);
  } catch {
    nr = !1;
  }
var fe = nr ? { passive: !1 } : !1, xo = function(e) {
  return e.tagName === "TEXTAREA";
}, Tt = function(e, r) {
  if (!(e instanceof Element))
    return !1;
  var t = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    t[r] !== "hidden" && // contains scroll inside self
    !(t.overflowY === t.overflowX && !xo(e) && t[r] === "visible")
  );
}, Ro = function(e) {
  return Tt(e, "overflowY");
}, Ao = function(e) {
  return Tt(e, "overflowX");
}, $r = function(e, r) {
  var t = r.ownerDocument, n = r;
  do {
    typeof ShadowRoot < "u" && n instanceof ShadowRoot && (n = n.host);
    var o = Ct(e, n);
    if (o) {
      var a = Pt(e, n), u = a[1], i = a[2];
      if (u > i)
        return !0;
    }
    n = n.parentNode;
  } while (n && n !== t.body);
  return !1;
}, Fo = function(e) {
  var r = e.scrollTop, t = e.scrollHeight, n = e.clientHeight;
  return [
    r,
    t,
    n
  ];
}, Io = function(e) {
  var r = e.scrollLeft, t = e.scrollWidth, n = e.clientWidth;
  return [
    r,
    t,
    n
  ];
}, Ct = function(e, r) {
  return e === "v" ? Ro(r) : Ao(r);
}, Pt = function(e, r) {
  return e === "v" ? Fo(r) : Io(r);
}, ko = function(e, r) {
  return e === "h" && r === "rtl" ? -1 : 1;
}, Mo = function(e, r, t, n, o) {
  var a = ko(e, window.getComputedStyle(r).direction), u = a * n, i = t.target, b = r.contains(i), l = !1, v = u > 0, s = 0, m = 0;
  do {
    var E = Pt(e, i), S = E[0], c = E[1], y = E[2], g = c - y - a * S;
    (S || g) && Ct(e, i) && (s += g, m += S), i instanceof ShadowRoot ? i = i.host : i = i.parentNode;
  } while (
    // portaled content
    !b && i !== document.body || // self content
    b && (r.contains(i) || r === i)
  );
  return (v && (Math.abs(s) < 1 || !o) || !v && (Math.abs(m) < 1 || !o)) && (l = !0), l;
}, _e = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, Br = function(e) {
  return [e.deltaX, e.deltaY];
}, zr = function(e) {
  return e && "current" in e ? e.current : e;
}, Lo = function(e, r) {
  return e[0] === r[0] && e[1] === r[1];
}, No = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, Do = 0, le = [];
function Wo(e) {
  var r = h.useRef([]), t = h.useRef([0, 0]), n = h.useRef(), o = h.useState(Do++)[0], a = h.useState(gr)[0], u = h.useRef(e);
  h.useEffect(function() {
    u.current = e;
  }, [e]), h.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(o));
      var c = Bt([e.lockRef.current], (e.shards || []).map(zr), !0).filter(Boolean);
      return c.forEach(function(y) {
        return y.classList.add("allow-interactivity-".concat(o));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(o)), c.forEach(function(y) {
          return y.classList.remove("allow-interactivity-".concat(o));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var i = h.useCallback(function(c, y) {
    if ("touches" in c && c.touches.length === 2)
      return !u.current.allowPinchZoom;
    var g = _e(c), A = t.current, O = "deltaX" in c ? c.deltaX : A[0] - g[0], R = "deltaY" in c ? c.deltaY : A[1] - g[1], d, W = c.target, B = Math.abs(O) > Math.abs(R) ? "h" : "v";
    if ("touches" in c && B === "h" && W.type === "range")
      return !1;
    var Y = $r(B, W);
    if (!Y)
      return !0;
    if (Y ? d = B : (d = B === "v" ? "h" : "v", Y = $r(B, W)), !Y)
      return !1;
    if (!n.current && "changedTouches" in c && (O || R) && (n.current = d), !d)
      return !0;
    var V = n.current || d;
    return Mo(V, y, c, V === "h" ? O : R, !0);
  }, []), b = h.useCallback(function(c) {
    var y = c;
    if (!(!le.length || le[le.length - 1] !== a)) {
      var g = "deltaY" in y ? Br(y) : _e(y), A = r.current.filter(function(d) {
        return d.name === y.type && (d.target === y.target || y.target === d.shadowParent) && Lo(d.delta, g);
      })[0];
      if (A && A.should) {
        y.cancelable && y.preventDefault();
        return;
      }
      if (!A) {
        var O = (u.current.shards || []).map(zr).filter(Boolean).filter(function(d) {
          return d.contains(y.target);
        }), R = O.length > 0 ? i(y, O[0]) : !u.current.noIsolation;
        R && y.cancelable && y.preventDefault();
      }
    }
  }, []), l = h.useCallback(function(c, y, g, A) {
    var O = { name: c, delta: y, target: g, should: A, shadowParent: jo(g) };
    r.current.push(O), setTimeout(function() {
      r.current = r.current.filter(function(R) {
        return R !== O;
      });
    }, 1);
  }, []), v = h.useCallback(function(c) {
    t.current = _e(c), n.current = void 0;
  }, []), s = h.useCallback(function(c) {
    l(c.type, Br(c), c.target, i(c, e.lockRef.current));
  }, []), m = h.useCallback(function(c) {
    l(c.type, _e(c), c.target, i(c, e.lockRef.current));
  }, []);
  h.useEffect(function() {
    return le.push(a), e.setCallbacks({
      onScrollCapture: s,
      onWheelCapture: s,
      onTouchMoveCapture: m
    }), document.addEventListener("wheel", b, fe), document.addEventListener("touchmove", b, fe), document.addEventListener("touchstart", v, fe), function() {
      le = le.filter(function(c) {
        return c !== a;
      }), document.removeEventListener("wheel", b, fe), document.removeEventListener("touchmove", b, fe), document.removeEventListener("touchstart", v, fe);
    };
  }, []);
  var E = e.removeScrollBar, S = e.inert;
  return h.createElement(
    h.Fragment,
    null,
    S ? h.createElement(a, { styles: No(o) }) : null,
    E ? h.createElement(_o, { gapMode: e.gapMode }) : null
  );
}
function jo(e) {
  for (var r = null; e !== null; )
    e instanceof ShadowRoot && (r = e.host, e = e.host), e = e.parentNode;
  return r;
}
ir(Xr, Wo);
var $o = function(e) {
  if (typeof document > "u")
    return null;
  var r = Array.isArray(e) ? e[0] : e;
  return r.ownerDocument.body;
}, de = /* @__PURE__ */ new WeakMap(), xe = /* @__PURE__ */ new WeakMap(), Re = {}, Xe = 0, _t = function(e) {
  return e && (e.host || _t(e.parentNode));
}, Bo = function(e, r) {
  return r.map(function(t) {
    if (e.contains(t))
      return t;
    var n = _t(t);
    return n && e.contains(n) ? n : (console.error("aria-hidden", t, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(t) {
    return !!t;
  });
}, zo = function(e, r, t, n) {
  var o = Bo(r, Array.isArray(e) ? e : [e]);
  Re[t] || (Re[t] = /* @__PURE__ */ new WeakMap());
  var a = Re[t], u = [], i = /* @__PURE__ */ new Set(), b = new Set(o), l = function(s) {
    !s || i.has(s) || (i.add(s), l(s.parentNode));
  };
  o.forEach(l);
  var v = function(s) {
    !s || b.has(s) || Array.prototype.forEach.call(s.children, function(m) {
      if (i.has(m))
        v(m);
      else
        try {
          var E = m.getAttribute(n), S = E !== null && E !== "false", c = (de.get(m) || 0) + 1, y = (a.get(m) || 0) + 1;
          de.set(m, c), a.set(m, y), u.push(m), c === 1 && S && xe.set(m, !0), y === 1 && m.setAttribute(t, "true"), S || m.setAttribute(n, "true");
        } catch (g) {
          console.error("aria-hidden: cannot operate on ", m, g);
        }
    });
  };
  return v(r), i.clear(), Xe++, function() {
    u.forEach(function(s) {
      var m = de.get(s) - 1, E = a.get(s) - 1;
      de.set(s, m), a.set(s, E), m || (xe.has(s) || s.removeAttribute(n), xe.delete(s)), E || s.removeAttribute(t);
    }), Xe--, Xe || (de = /* @__PURE__ */ new WeakMap(), de = /* @__PURE__ */ new WeakMap(), xe = /* @__PURE__ */ new WeakMap(), Re = {});
  };
}, qo = function(e, r, t) {
  var n = Array.from(Array.isArray(e) ? e : [e]), o = r || $o(e);
  return o ? (n.push.apply(n, Array.from(o.querySelectorAll("[aria-live]"))), zo(n, o, t, "aria-hidden")) : function() {
    return null;
  };
}, Yo = gr(), Uo = `
 [` + at + `] {
   pointer-events: none !important;
 }
`, Ho = function() {
  return h.createElement(Yo, { styles: Uo });
}, qr = function(e) {
  return "current" in e ? e.current : e;
};
function Vo(e) {
  var r = e.setLockProps, t = e.onEscapeKey, n = e.onClickOutside, o = e.shards, a = e.onActivation, u = e.onDeactivation, i = e.noIsolation, b = Yr(void 0), l = b[0], v = b[1], s = Sr(null), m = Sr(0);
  return h.useEffect(function() {
    var E = function(g) {
      g.defaultPrevented || (g.code === "Escape" || g.key === "Escape" || g.keyCode === 27) && t && t(g);
    }, S = function(g) {
      g.defaultPrevented || g.target === s.current || g instanceof MouseEvent && g.button !== 0 || o && o.map(qr).some(function(A) {
        return A && A.contains(g.target) || A === g.target;
      }) || n && n(g);
    }, c = function(g) {
      S(g), m.current = g.touches.length;
    }, y = function(g) {
      m.current = g.touches.length;
    };
    if (l)
      return document.addEventListener("keydown", E), document.addEventListener("mousedown", S), document.addEventListener("touchstart", c), document.addEventListener("touchend", y), function() {
        document.removeEventListener("keydown", E), document.removeEventListener("mousedown", S), document.removeEventListener("touchstart", c), document.removeEventListener("touchend", y);
      };
  }, [l, n, t]), Ze(function() {
    if (l)
      return a && a(l), function() {
        u && u();
      };
  }, [!!l]), Ze(function() {
    var E = function() {
      return null;
    }, S = !1, c = function(g) {
      i || (E = qo($t([g], (o || []).map(qr)), document.body, at)), v(function() {
        return g;
      });
    }, y = function() {
      E(), S || v(null);
    };
    return r({
      onMouseDown: function(g) {
        s.current = g.target;
      },
      onTouchStart: function(g) {
        s.current = g.target;
      },
      onActivation: c,
      onDeactivation: y
    }), function() {
      S = !0, r(!1);
    };
  }, []), h.createElement(Ho, null);
}
const Go = ir(ot, Vo);
var Xo = function(e) {
  return h.createElement(Go, $({}, e));
}, Zo = h.forwardRef(function(e, r) {
  return h.createElement(sn, $({}, e, { ref: r, sideCar: Xo }));
});
const Ko = "common", Jo = {
  closeButtonLabel: "Close"
}, Qo = {
  namespace: Ko,
  strings: Jo
}, ea = "_overlay_1iffn_1", ra = "_fade-in_1iffn_1", ta = "_modal-container_1iffn_5", na = "_slide-down_1iffn_1", oa = "_size-sm_1iffn_12", aa = "_size-md_1iffn_16", ia = "_size-lg_1iffn_20", ua = "_size-xl_1iffn_24", ca = "_size-full_1iffn_28", sa = "_page-width_1iffn_33", fa = "_size-auto_1iffn_38", la = "_modal_1iffn_5", da = "_close-icon_1iffn_53", va = "_content_1iffn_57", U = {
  overlay: ea,
  fadeIn: ra,
  modalContainer: ta,
  slideDown: na,
  sizeSm: oa,
  sizeMd: aa,
  sizeLg: ia,
  sizeXl: ua,
  sizeFull: ca,
  pageWidth: sa,
  sizeAuto: fa,
  modal: la,
  closeIcon: da,
  content: va
}, ma = {
  sm: U.sizeSm,
  md: U.sizeMd,
  lg: U.sizeLg,
  xl: U.sizeXl,
  full: U.sizeFull,
  auto: U.sizeAuto,
  pageWidth: U.pageWidth
};
function Pa(e) {
  const {
    closeOnClickOutside: r = !1,
    closeOnEscape: t = !1,
    onClose: n,
    overlayClassName: o,
    size: a = "md",
    withoutCloseButton: u = !1,
    className: i,
    actions: b,
    childrenContainerClassName: l,
    modalContainerClassName: v,
    ...s
  } = e, m = Wt(Qo);
  Ze(
    () => {
      const y = document.documentElement.style.scrollbarGutter;
      return document.documentElement.style.scrollbarGutter = "initial", () => {
        document.documentElement.style.scrollbarGutter = y;
      };
    },
    []
  );
  const E = ma[a], S = wr(() => {
    r && n && n();
  }, [n, r]), c = wr(() => {
    t && n && n();
  }, [n, t]);
  return /* @__PURE__ */ be(Lt, { className: Te(U.overlay, o), children: /* @__PURE__ */ be(
    Zo,
    {
      className: Te(U.modalContainer, v, E),
      onClickOutside: S,
      onEscapeKey: c,
      gapMode: "padding",
      children: /* @__PURE__ */ be(
        Dt,
        {
          ...s,
          withInternalPadding: !0,
          withoutWrapInHeading: !0,
          className: Te(U.modal, i),
          childrenContainerClassName: Te(U.content, l),
          actions: !u || b ? /* @__PURE__ */ Rt(At, { children: [
            b,
            /* @__PURE__ */ be(
              Nt,
              {
                name: void 0,
                onClick: n,
                variant: "tertiary",
                title: m.closeButtonLabel,
                children: /* @__PURE__ */ be(Mt, { className: U.closeIcon })
              }
            )
          ] }) : void 0
        }
      )
    }
  ) });
}
export {
  Pa as default
};
